import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { ParamMap } from '@angular/router';

import { type } from '@app/util/util';
import { BusResultsMobile, BusResultDesktop, SearchResultsData } from '@app/entities/bus-results';
import { BusType } from '@search-bar/entities/bus-type';
import { BusSearchPayload } from '@buses/bus-results/entities/bus-search-payload';
import { RequestSearchPayload, SearchPayload } from '@buses/bus-results/entities/request-search.payload';
import { FetchFiltersPayload, FetchFlightsOptionPayload } from '@buses/bus-results/entities/bus-filters-payload';
import { BusClassTypes } from '@buses/bus-results/entities/bus-type';
import { AirFiltersResponse } from '@shared/magic-filter-bar/entities/filter-types';

export const searchBusesAction = createAction(type('[BusesResults/API] Search buses'),
  props<{ payload: BusSearchPayload }>());
export const fetchTokenAction = createAction(type('[BusesResults/API] Fetch token'),
  props<{ payload: RequestSearchPayload }>());
export const searchBusesForDesktopAction = createAction(type('[BusesResults/API] Search buses for desktop'),
  props<{ payload: SearchPayload }>());
export const searchBusesForDesktopSuccessAction = createAction(type('[BusesResults/API] Search for desktop buses Success'),
  props<{ busesResults: BusResultDesktop[] }>());
export const searchBusesForDesktopErrorAction = createAction(type('[BusesResults/Data] BusesResults For Desktop error'),
  props<{ payload: HttpErrorResponse }>());
export const searchBusesForMobileAction = createAction(type('[BusesResults/API] Search buses for mobile'),
  props<{ payload: SearchPayload }>());
export const searchBusesForMobileSuccessAction = createAction(type('[BusesResults/API] Search for mobile buses success'),
  props<{ busesResults: BusResultsMobile[] }>());
export const searchBusesForMobileErrorAction = createAction(type('[BusesResults/Data] BusesResults For Mobile error'),
  props<{ payload: HttpErrorResponse }>());
export const fetchFiltersBusesAction = createAction(type('[BusesResults/API] Fetch filters buses'),
  props<{ payload: FetchFiltersPayload }>());
export const fetchFiltersBusesSuccessAction = createAction(type('[BusesResults/API] Fetch filters buses success'),
  props<{ filters: AirFiltersResponse }>());
export const noResultsSearchBusesAction = createAction(type('[BusesResults/API] No results for buses search'));
export const saveSearchBusesData = createAction(type('[BusesResults/DATA] Save search data'),
  props<{ data: SearchResultsData }>());
export const clearBusesResultsAction = createAction(type('[BusesResults/DATA] Clear buses results'),
  props<{ isMobile: boolean }>());
export const fetchBusesOptionAction = createAction(type('[BusesResults/API] Fetch buses option'),
  props<{ payload: FetchFlightsOptionPayload }>());
export const fetchBusesDataSearchDeeplinkAction =
  createAction(type('[BusesResults/Data] Fetch buses data search deeplink option'),
    props<{ paramsMap: ParamMap, busType: BusType, busClass: BusClassTypes }>());

export const busesResultsActions = {
  searchBusesAction
};
